// import { Chip, MenuItem, Select } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";

// const StatusCell = ({ params, setSelectedRow, setOpenStatusChangeModal }) => {
//   return (
//     <Select
//       value={params.value}
//       renderValue={(value) => (
//         <Chip
//           icon={value === 1 ? <CheckCircleIcon /> : <CancelIcon />}
//           label={value === 1 ? "Active" : "Inactive"}
//           color={value === 1 ? "success" : "default"}
//           variant="outlined"
//         />
//       )}
//       label="Status"
//       onChange={() => {
//         setSelectedRow(params.row);
//         setOpenStatusChangeModal(true);
//       }}
//       sx={{
//         height: "100%",
//         minHeight: "52px",
//         border: "none",
//         "& .MuiOutlinedInput-notchedOutline": { border: "none" }, // Remove the outline
//         "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
//         "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
//       }}
//     >
//       <MenuItem value={1}>
//         <Chip label="Active" color="success" />
//       </MenuItem>
//       <MenuItem value={0}>
//         <Chip label="Inactive" color="default" />
//       </MenuItem>
//     </Select>
//   );
// };

// export default StatusCell;


// ***************************************************************************************************************
import { Chip, MenuItem, Select } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const StatusCell = ({ params, setSelectedRow, setOpenStatusChangeModal }) => {
  // Check if status update is allowed
  const canUpdateStatus = params.row.allow_status_update === 1;

  return (
    <Select
      value={params.value}
      renderValue={(value) => (
        <Chip
          icon={value === 1 ? <CheckCircleIcon /> : <CancelIcon />}
          label={value === 1 ? "Active" : "Inactive"}
          color={value === 1 ? "success" : "default"}
          variant="outlined"
        />
      )}
      label="Status"
      onChange={() => {
        if (canUpdateStatus) {
          setSelectedRow(params.row);
          setOpenStatusChangeModal(true);
        }
      }}
      // Disable only when not allowed
      disabled={!canUpdateStatus}
      // Keep the dropdown arrow when enabled, remove when disabled
      IconComponent={!canUpdateStatus ? () => null : undefined}
      sx={{
        height: "100%",
        minHeight: "52px",
        border: "none",
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
        // Keep exact same styling when disabled
        "&.Mui-disabled": {
          opacity: "1 !important",
          cursor: "default",
        },
        "&.Mui-disabled .MuiChip-root": {
          cursor: "default",
        },
      }}
      // Prevent menu from opening when disabled
      MenuProps={!canUpdateStatus ? { open: false } : undefined}
    >
      <MenuItem value={1}>
        <Chip label="Active" color="success" />
      </MenuItem>
      <MenuItem value={0}>
        <Chip label="Inactive" color="default" />
      </MenuItem>
    </Select>
  );
};

export default StatusCell;